/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  
  fetchCandidat({ commit },date) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_Candidat_Statistic/${date}`)
        .then((response) => {
          console.log('responsefetchCandidat',response.data)
          commit('SET_CANDIDATS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchFormateur({ commit },date) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_Formateur_Statistic/${date}`)
        .then((response) => {
          //console.log('response',response.data)
          commit('SET_FORMATEURS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchFormation({ commit },date) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_Formation_Statistic/${date}`)
        .then((response) => {
          //console.log('response',response.data)
          commit('SET_FORMATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDomaine({ commit },date) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_domaine_Statistic/${date}`)
        .then((response) => {
          //console.log('response',response.data)
          commit('SET_DOMAINES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchFormateur_salaire({ commit },date) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_Formateur_salaire_Statistic/${date}`)
        .then((response) => {
          //console.log('response',response.data)
          commit('SET_FORMATEURS_SA', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchGain({ commit },date) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_gain_salaire_Statistic/${date}`)
        .then((response) => {
          console.log('response',response.data)
          commit('SET_GAINS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchParticipation({ commit },date) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_participation_candidat_Statistic/${date}`)
        .then((response) => {
          //console.log('response',response.data)
          commit('SET_PARTICIPATION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchParticipationFormation({ commit },date) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_formation_info_order/${date}`)
        .then((response) => {
          //console.log('response',response.data)
          commit('SET_PARTICIPATIONFORMATION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchParticipationDomaine({ commit },date) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_domaine_info_order/${date}`)
        .then((response) => {
          //console.log('response',response.data)
          commit('SET_PARTICIPATIONDOMAINE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchFormationGain({ commit },date) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_formation_info_Gain/${date}`)
        .then((response) => {
          //console.log('response',response.data)
          commit('SET_GAINFORMATION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDomaineGain({ commit },date) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_domaine_info_Gain/${date}`)
        .then((response) => {
          //console.log('response',response.data)
          commit('SET_GAINDOMAINE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAnneeFormationGain({ commit },date) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_Total_info_Gain/${date}`)
        .then((response) => {
          //console.log('response',response.data)
          commit('SET_GAINANNUELLE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  /*fetchUsers({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/getCandidat")
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },*/
  //formateur
  fetchClassesFormateur({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_classe_formateur_id/${userId}`)
        .then((response) => {
          console.log('userId',userId)
          commit('SET_STAT_CLASSE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchFormationsFormateur({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_formation_formateur_id/${userId}`)
        .then((response) => {
          console.log('response.data',response.data)
          commit('SET_STAT_FORMATION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDomainesFormateur({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_domaine_formateur_id/${userId}`)
        .then((response) => {
          console.log('userId',userId)
          console.log('dataaaaaaaaaa',response.data)
          commit('SET_STAT_DOMAINE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  //candidat
  fetchFormationsCandidat({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_formation_candidat_id/${userId}`)
        .then((response) => {
          console.log('response.data',response.data)
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
}
